import React, { useState } from "react";
// @ts-ignore
import { setDoc, doc } from "firebase/firestore";
// @ts-ignore
import { db } from "../../utils/firebase.js";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
//@ts-ignore
import CryptoJS from 'crypto-js';

const AddUser = () => {
  const SECRET_KEY = process.env.REACT_APP_ENCRYPTION_KEY;

  const [formData, setFormData] = useState({
    businessName: "",
    email: "",
    password: "",
    phoneNumber: "",
    whatsappNumber: "",
    businessType: "",
    homeDeliveryAvailable: false,
    takeAwayAvailable: false,
    lastPaymentDate: "",
    lastPaymentAmount: "",
    nextPaymentDate: "",
    nextPaymentAmount: "",
    status: "active",
    createdDate: new Date().toISOString(),
  });
  const [showPassword, setShowPassword] = useState(false);

  const encryptPassword = (password : string) => {
    return CryptoJS.AES.encrypt(password, SECRET_KEY).toString();
  };

  // Decrypt password - for verification purposes
  const decryptPassword = (encryptedPassword: string) => {
    const bytes = CryptoJS.AES.decrypt(encryptedPassword, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  };


  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox" ? (e.target as HTMLInputElement).checked : value,
    }));
  };

  const validate = () => {
    if (
      !formData.businessName ||
      !formData.email ||
      !formData.password ||
      !formData.phoneNumber ||
      !formData.whatsappNumber ||
      !formData.businessType ||
      !formData.status
    ) {
      toast.error("Please fill in all required fields.");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address.");
      return false;
    }

    const phoneRegex = /^[0-9]{12}$/;
    if (!phoneRegex.test(formData.phoneNumber)) {
      toast.error("Enter a valid phone number.");
      return false;
    }

    if (!phoneRegex.test(formData.whatsappNumber)) {
      toast.error("Enter a valid whatsapp number.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // Add your form submission logic
    //console.log("formmsdsd", formData);
    if (validate()) {
      try {
        const encryptedData = {
          ...formData,
          password: encryptPassword(formData?.password)
        };

        //console.log("encrypted data", encryptedData)
        await setDoc(doc(db, "userDetails", formData.email), encryptedData);
        //console.log("Form Data Submitted:", encryptedData);
        toast.success("User added successfully!");
        setFormData({
          businessName: "",
          email: "",
          password: "",
          phoneNumber: "",
          whatsappNumber: "",
          businessType: "",
          homeDeliveryAvailable: false,
          lastPaymentDate: "",
          lastPaymentAmount: "",
          nextPaymentDate: "",
          nextPaymentAmount: "",
          status: "active",
          takeAwayAvailable: false,
          createdDate: new Date().toISOString()
        });
      } catch (error) {
        console.error("Error adding business: ", error);
        toast.error("Error adding user. Please try again.");
      }
    } else {
      console.log(" all details not added");
    }
  };

  return (
    <div className="max-w-2xl  bg-white rounded-lg shadow p-4 lg:p-6">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

      <h2 className="text-xl font-bold mb-6">Add New User</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Business Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Business Name *
          </label>
          <input
            type="text"
            name="businessName"
            value={formData.businessName}
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Email *{" "}
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Password */}
        <div>
          <label className="block text-sm font-medium text-gray-700 self-center">
            Password *
          </label>
          <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            value={formData.password}
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
          <span
            className="absolute inset-y-0 right-3 flex items-center cursor-pointer justify-center"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? (
              <FaEye className="text-gray-500" />
            ) : (
              <FaEyeSlash className="text-gray-500" />
            )}
          </span>
          </div>
        </div>

        {/* Phone Number */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Phone Number *
          </label>
          <input
            type="tel"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Whatsapp Phone Number */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Whatsapp Phone Number *
          </label>
          <input
            type="tel"
            name="whatsappNumber"
            value={formData.whatsappNumber}
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/*  */}

        {/* Last Payment Date */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Last Payment Date
          </label>
          <input
            type="date"
            name="lastPaymentDate"
            value={formData.lastPaymentDate}
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Last Payment Amount */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Last Payment Amount
          </label>
          <input
            type="number"
            name="lastPaymentAmount"
            value={formData.lastPaymentAmount}
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Next Payment Date */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Next Payment Date
          </label>
          <input
            type="date"
            name="nextPaymentDate"
            value={formData.nextPaymentDate}
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Next Payment Amount */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Next Payment Amount
          </label>
          <input
            type="number"
            name="nextPaymentAmount"
            value={formData.nextPaymentAmount}
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Status (Active/Inactive) */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Status *
          </label>
          <select
            name="status"
            // value={formData.status}
            onChange={handleChange}
            required
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        {/* Business Type */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Business Type *
          </label>
          <select
            name="businessType"
            value={formData.businessType}
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          >
            <option value="" disabled>
              Select Business Type
            </option>
            <option value="Restaurant">Restaurant</option>
            <option value="Hotel">Hotel</option>
          </select>
        </div>

        {/* Home Delivery Available */}
        {formData.businessType === 'Restaurant' && (
          <div className="flex items-center">
            <div className="flex items-center">
          <input
            type="checkbox"
            name="homeDeliveryAvailable"
            checked={formData.homeDeliveryAvailable}
            onChange={handleChange}
            className="rounded text-blue-600 focus:ring-blue-500"
          />
          <label className="ml-2 text-sm text-gray-700">
            Home Delivery Available
          </label>
          </div>
          <div className="flex items-center ml-5">
          <input
            type="checkbox"
            name="takeAwayAvailable"
            checked={formData.takeAwayAvailable}
            onChange={handleChange}
            className="rounded text-blue-600 focus:ring-blue-500"
          />
          <label className="ml-2 text-sm text-gray-700">
            Take Away Available
          </label>
          </div>
          
          </div>
        )}
       

        {/* Add Button */}
        <div>
          <button
            type="submit"
            className="w-full bg-[#0b3a28] text-white px-6 py-2 rounded-lg hover:bg-[#1c2822]"
          >
            Add User
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddUser;
